import React from "react";
import { CollaboratorProfileCard } from "../CollaboratorProfileCard";
import { CollaboratorAnagraphic } from "../../../types/api/collaborators.type";
import {
  EMPTY_STRING,
  IN_ABSTRACT_LABEL,
  EXPERIENCE_LABEL,
} from "../../../constants/Dictionary";
import { FontWeightEnum, IconSizeEnum } from "../../../types/AppTypes";
import {
  Avatar,
  AvatarDimensionsEnum,
  AvatarDirectionEnum,
} from "../../core/Avatar/Avatar";
import { BodyTyp, CaptionsTyp, TitlesTyp } from "../../Typography/Typography";
import { ReactComponent as BriefcaseIcon } from "../../../icons/briefcase.svg";
import { ReactComponent as FileCheckIcon } from "../../../icons/fileCheck.svg";
import { IconManager } from "../../core/IconManager/IconManager";
import { theme } from "../../../constants/StyledComponents";
import { getInitials } from "../../../utils/collaborators.utils";
import { StyledAvatarLayout } from "../../core/Avatar/Avatar.styled";
import { getYearsAndMonths } from "../../../utils/date/date.utils";

type CollaboratorCardProps = {
  collaboratorId: number;
  anagraphic: CollaboratorAnagraphic | null;
  isInterim: boolean;
};

export const CollaboratorCard = ({
  collaboratorId,
  anagraphic,
  isInterim,
}: CollaboratorCardProps) => {
  const name = anagraphic?.name || EMPTY_STRING;
  const surname = anagraphic?.surname || EMPTY_STRING;
  const email = anagraphic?.email || EMPTY_STRING;
  const totalExperienceMonths = anagraphic?.experience.totalExperienceMonths;
  const companyExperienceMonths =
    anagraphic?.experience.companyExperienceMonths;

  const timeOfExperienceTotal =
    totalExperienceMonths !== undefined && totalExperienceMonths !== null
      ? getYearsAndMonths(totalExperienceMonths)
      : EMPTY_STRING;

  const timeOfExperienceAbstract =
    companyExperienceMonths !== undefined && companyExperienceMonths !== null
      ? getYearsAndMonths(companyExperienceMonths)
      : EMPTY_STRING;

  return (
    <CollaboratorProfileCard
      content={
        <StyledAvatarLayout $direction={AvatarDirectionEnum.HORIZONTAL}>
          <Avatar
            variant={AvatarDimensionsEnum.BIG}
            collaboratorId={collaboratorId}
            initials={getInitials(name, surname)}
          />
          <div className="avatar-name-text">
            <TitlesTyp
              fontWeight={FontWeightEnum.SEMIBOLD}
              variant="3"
              noTranslate
            >
              {`${surname} ${name}`}
            </TitlesTyp>
            {!isInterim ? (
              <BodyTyp fontWeight={FontWeightEnum.REGULAR} noTranslate>
                {email}
              </BodyTyp>
            ) : null}
          </div>
        </StyledAvatarLayout>
      }
      bottomContent={
        <>
          <div className="card-row">
            <IconManager size={IconSizeEnum.SMALL} color={theme.colors.purple}>
              <BriefcaseIcon />
            </IconManager>
            <div>
              <CaptionsTyp fontWeight={FontWeightEnum.REGULAR} noTranslate>
                {EXPERIENCE_LABEL}
              </CaptionsTyp>
              <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD} noTranslate>
                {timeOfExperienceTotal}
              </BodyTyp>
            </div>
          </div>
          <div className="card-row">
            <IconManager size={IconSizeEnum.SMALL} color={theme.colors.purple}>
              <FileCheckIcon />
            </IconManager>
            <div>
              <CaptionsTyp fontWeight={FontWeightEnum.REGULAR}>
                {IN_ABSTRACT_LABEL}
              </CaptionsTyp>
              <BodyTyp fontWeight={FontWeightEnum.SEMIBOLD}>
                {timeOfExperienceAbstract}
              </BodyTyp>
            </div>
          </div>
        </>
      }
    />
  );
};
